import { useEffect } from "react";

export function trackPageView() {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
  });
}

const UET_TAG_ID = process.env.REACT_APP_MICROSOFT_UET_TAG_ID;
let uetLoadPromise;

export function loadUet() {
  if (typeof window === "undefined" || !UET_TAG_ID) return Promise.resolve(false);
  if (window.uetq && window.uetq.__loaded) return Promise.resolve(true);
  if (uetLoadPromise) return uetLoadPromise;
  uetLoadPromise = new Promise((resolve) => {
    window.uetq = window.uetq || [];
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://bat.bing.com/bat.js";
    script.onload = () => {
      if (typeof window.UET !== "function") return resolve(false);
      const config = { ti: UET_TAG_ID, enableAutoSpaTracking: true };
      config.q = window.uetq;
      window.uetq = new window.UET(config);
      window.uetq.push("pageLoad");
      window.uetq.__loaded = true;
      resolve(true);
    };
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
  return uetLoadPromise;
}

export function uetEvent(action, fields = {}) {
  if (typeof window === "undefined") return;
  window.uetq = window.uetq || [];
  window.uetq.push("event", action, fields);
}

function gaEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

// Fires after a lead form is successfully accepted by the backend.
// UET action names match the Microsoft Ads auto-created goals ("Submit lead form" / "Contact").
export function trackLeadSubmit() {
  gaEvent("generate_lead");
  uetEvent("submit_lead_form", { event_category: "lead", event_label: "contact_form" });
}

// Fires on any tap-to-call link click.
export function trackPhoneTap() {
  gaEvent("contact", { method: "phone" });
  uetEvent("contact", { event_category: "phone", event_label: "header_or_cta" });
}

// Attach on public pages: one delegated listener for every tel: link on the page.
export function usePhoneTapTracking() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (a) trackPhoneTap();
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
}
